import * as React from 'react';
import { Component } from 'react';
import { observer } from 'mobx-react';
import { inject } from '../utils';
import { withTheme } from 'styled-components';
import { styled } from '../utils/styled';
import { propStyles } from '../utils/propStyles';
import { opacity } from '../utils/customPropStyles';
import Icon from './Icon';
import { SORT_DIRECTIONS } from '../constants';
import { computed } from 'mobx';
import { AccessibilityStore } from '../stores';
import { Theme } from '../models/Theme';
import { translate } from './Translate';
import { TranslationStore } from '../stores';

const SortToggleButton = styled<any, any>(
    'button',
    'sortToggleButton',
    'sortToggle'
)`
    ${propStyles};
    ${opacity};
    outline: none;
    & > img {
        position: absolute;
        top: -50%;
        left: -50%;
    }
`;

SortToggleButton.defaultProps = {
    position: 'relative',
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    bgColor: 'transparent',
    borderStyle: 'none',
    cursor: 'pointer',
    height: '1em',
    width: '1em',
    overflow: 'visible',
};

interface SortToggleProps {
    theme?: Theme;
    direction: 'ASC' | 'DESC' | '';
    disabled?: boolean;
    metricContext?: string;
    accessibilityStore?: AccessibilityStore;
    translationStore?: TranslationStore;
    onClick(): void;
}

@inject('accessibilityStore', 'translationStore')
@observer
class SortToggle extends Component<SortToggleProps> {
    @computed
    get fileName() {
        const { direction } = this.props;
        return direction === SORT_DIRECTIONS.ASC
            ? 'ColumnSortAscIcon'
            : direction === SORT_DIRECTIONS.DESC
            ? 'ColumnSortDescIcon'
            : 'ColumnSortOffIcon';
    }

    @computed
    get selected() {
        const { direction } = this.props;
        return (
            direction === SORT_DIRECTIONS.ASC ||
            direction === SORT_DIRECTIONS.DESC
        );
    }

    @computed
    get ariaLabel() {
        const { direction, translationStore } = this.props;
        let label;
        switch (direction) {
            case '':
            case 'DESC':
                label = 'Sort in ascending order';
                break;
            case 'ASC':
                label = 'Sort in descending order';
                break;
            default:
                label = '';
                break;
        }
        if (label) {
            return translate(translationStore, label);
        }
        return;
    }
    render() {
        const { theme, metricContext } = this.props;

        return (
            <SortToggleButton
                aria-label={this.ariaLabel}
                data-selected={this.selected}
                opacity={this.selected ? '1' : '0.25'}
                data-metric-id={`sortToggle-${metricContext}`}
                {...theme.SortToggle}
                {...this.props}
            >
                <Icon fileName={this.fileName} />
            </SortToggleButton>
        );
    }
}

export default withTheme(SortToggle) as any;



// WEBPACK FOOTER //
// ./src/Components/SortToggle.tsx